const l = {
  name: "ManagedSoftwareCenter",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M16,25c-0.8,0-1.6,0.3-2.1,0.9C13.3,26.4,13,27.2,13,28c0,1.7,1.3,3,3,3h8c0.8,0,1.6-0.3,2.1-0.9
			c0.6-0.5,0.9-1.3,0.9-2.1c0-0.9-0.4-1.7-1.1-2.3l0,0l0,0C25.4,25.3,24.7,25,24,25H16z M15.3,27.3c0.2-0.2,0.4-0.3,0.7-0.3h8
			c0.2,0,0.5,0.1,0.6,0.2c0.2,0.2,0.4,0.5,0.4,0.8c0,0.3-0.1,0.5-0.3,0.7l0,0l0,0C24.5,28.9,24.3,29,24,29h-8c-0.5,0-1-0.5-1-1
			C15,27.7,15.1,27.5,15.3,27.3L15.3,27.3L15.3,27.3z"/>
		<path class="st0" d="M5.7,0L0,5.7L6.4,12l-2.8,2.8l-1,6.2H0l4.2,19h31.6L40,21h-5V4c0-1.1-0.5-2.1-1.2-2.8C33.1,0.5,32.1,0,31,0
			c-2.2,0-4,1.8-4,4v17h-0.3l-9-9l4.4-4.4c1.6-1.6,1.6-4.1,0-5.7c-1.6-1.6-4.1-1.6-5.7,0L12,6.4L5.7,0z M33,18.9V21h-4v-2.1H33z
			 M33,16.9h-4V4c0-1.1,0.9-2,2-2c0.6,0,1.1,0.2,1.4,0.6C32.8,3,33,3.5,33,4V16.9z M37.5,23l-3.3,15H5.8L2.5,23H37.5z M5.7,2.8
			l4.9,4.9l-2.8,2.8L2.8,5.7L5.7,2.8z M13.4,16.2l2.8-2.8l7.6,7.6h-5.7L13.4,16.2z M9.2,20.4l2.8-2.8l3.3,3.3H5.7L9.2,20.4z
			 M20.7,3.4c0.8,0.8,0.8,2,0,2.8L20,6.9l-2.8-2.8l0.7-0.7C18.6,2.6,19.9,2.6,20.7,3.4z M18.5,8.3L8.3,18.6l-3.4,0.5l0.6-3.4
			L15.7,5.5L18.5,8.3z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as ManagedSoftwareCenter
};
